'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'envelope';
var width = 512;
var height = 512;
var aliases = [128386,9993,61443];
var unicode = 'f0e0';
var svgPathData = ['M16 80l480 0 0 52.1-240 185.8-240-185.8 0-52.1zm0 72.3l235.1 182 4.9 3.8 4.9-3.8 235.1-182 0 279.7-480 0 0-279.7z', 'M0 64l512 0 0 384-512 0 0-384zM496 80l-480 0 0 52.1 240 185.8 240-185.8 0-52.1zM16 152.3l0 279.7 480 0 0-279.7-235.1 182-4.9 3.8-4.9-3.8-235.1-182z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;